// extracted by mini-css-extract-plugin
module.exports = {"compass":"styles_compass__xQTuy"};